<script setup lang="ts">
import accessibilityInformation from '@/domains/esg/composables/content/accessibility-information'

const { t } = useI18n()

const accessibilityInformationTranslated = {
  title: t(accessibilityInformation.title),
  list: accessibilityInformation.list.map((item) => {
    return { content: t(item.content) }
  }),
}
</script>

<template>
  <UiPolicy
    version="document"
    :title="accessibilityInformationTranslated.title"
    :subtitle="''"
    :policy="accessibilityInformationTranslated"
    :table-of-contents="false"
  />
</template>
